import { Navigate } from 'react-router-dom';
import AppLayout from '@/pages/AppLayout';
import AuthLayout from '@/pages/AuthLayout';
import Dashboard from '@/pages/Dashboard';
import NotFound404 from '@/pages/NotFound404';
import ReviewLayout from '@/pages/ReviewLayout';
import SignLayout from '@/pages/SignLayout';
import accountRoutes from '@/routes/account';
import authRoutes from '@/routes/auth';
import contactRoutes from '@/routes/contacts';
import safeTransferRoutes from '@/routes/safeTransfer';
import kycRoutes from '@/routes/kyc';
import reviewRoutes from '@/routes/review';
import signingsRoutes from '@/routes/signings';
import signRoutes from '@/routes/sign';
import templateRoutes from '@/routes/templates';
import toolsRoutes from '@/routes/tools';
import contentCredentialsRoutes from '@/routes/contentCredentials';
import settingsRoutes from '@/routes/settings';
import PdfEditorDev from '@/pages/PdfEditorDev/PdfEditorDev';
import preloadChunks from '@/routes/preloadChunks.util';
import PrivateRoute from '@/routes/PrivateRoute';

// DEV-ONLY: the PDFium-native editor rewrite harness (B1). Standalone, no auth
// layout — a real-browser/real-WASM bench to A/B the new render path and run
// the clip-strip parity gate. Stripped from production builds.
const devRoutes = import.meta.env.DEV
  ? [{ path: '/pdf-editor-dev', element: <PdfEditorDev /> }]
  : [];

const app = [
  ...devRoutes,
  {
    // Public recipient landing — the target of safe-transfer invite emails
    // (FRONTEND_SAFE_TRANSFER_RECIPIENT_URL). Standalone: recipients have no
    // account, they authenticate with the link's token.
    path: '/safe-data-transfer/:transferId/access',
    lazy: async () => ({
      Component: (await preloadChunks['safeTransfer.access']()).default,
    }),
  },
  {
    // Public recipient landing — the target of safe-transfer invite emails
    // (FRONTEND_SAFE_TRANSFER_RECIPIENT_URL). Standalone: recipients have no
    // account, they authenticate with the link's token.
    path: '/safe-data-transfer/:transferId/access',
    lazy: async () => ({
      Component: (await preloadChunks['safeTransfer.access']()).default,
    }),
  },
  {
    // Consent screen for MCP hosts, the target of the backend's
    // /api/oauth/authorize redirect. Standalone: no app shell around a
    // third-party permission prompt.
    path: '/oauth/authorize',
    element: <PrivateRoute />,
    children: [
      {
        index: true,
        lazy: async () => ({
          Component: (await preloadChunks['oauth.authorize']()).default,
        }),
      },
    ],
  },
  {
    element: <AuthLayout />,
    children: [
      { path: '', element: <Navigate to="/auth/register" /> },
      ...authRoutes,
    ],
  },
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { path: 'dashboard', element: <Dashboard /> },
      {
        path: 'subscriptionMissing',
        element: <Navigate to="/account/subscription" />,
      },
      ...kycRoutes,
      ...contactRoutes,
      ...templateRoutes,
      ...safeTransferRoutes,
      ...signingsRoutes,
      ...accountRoutes,
      ...toolsRoutes,
      ...contentCredentialsRoutes,
      ...settingsRoutes,
    ],
  },
  {
    path: '/sign',
    element: <SignLayout />,
    children: [...signRoutes],
  },
  {
    path: '/review',
    element: <ReviewLayout />,
    children: [...reviewRoutes],
  },
  {
    path: '*',
    element: <NotFound404 />,
  },
];

export default app;
